import { render } from "./ServiceTerm.vue?vue&type=template&id=5ec78b76&scoped=true"
import script from "./ServiceTerm.vue?vue&type=script&lang=js"
export * from "./ServiceTerm.vue?vue&type=script&lang=js"

import "./ServiceTerm.vue?vue&type=style&index=0&id=5ec78b76&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec78b76"]])

export default __exports__